import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faEye, faEyeSlash, faTrashAlt,
} from '@fortawesome/pro-light-svg-icons'

interface DeleteIconProps {
  hidden: boolean,
  isMaster: boolean,
}

const DeleteIcon = (props: DeleteIconProps) => {
  const { hidden, isMaster } = props

  if (isMaster){
    return <FontAwesomeIcon icon={faTrashAlt} />
  }

  if (hidden){
    return <FontAwesomeIcon icon={faEye} />
  }

  return (
    <FontAwesomeIcon icon={faEyeSlash} />
  )
}

export default DeleteIcon
